const currencyFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export function formatCurrency(value?: number | null): string {
    return value === undefined || value === null ? '' : currencyFormatter.format(value);
}

export function formatCompactNumber(value?: number | null): string {
    return new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 }).format(value || 0);
}

// Valor de campo numérico (input, select) para o request: vazio ou inválido vira undefined
export function parseNumberInput(value: unknown): number | undefined {
    if (value === undefined || value === null || String(value).trim() === '') return undefined;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}

// Tamanho em bytes legível (B, KB, MB, GB), com vírgula decimal
export function formatFileSize(bytes?: number | null): string {
    if (bytes === undefined || bytes === null || bytes < 0) return '';
    const units = ['B', 'KB', 'MB', 'GB'];
    let value = bytes;
    let unit = 0;
    while (value >= 1024 && unit < units.length - 1) {
        value /= 1024;
        unit++;
    }
    const digits = unit === 0 || value >= 100 ? 0 : 1;
    return `${value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: digits })} ${units[unit]}`;
}
